import { LAYOUTS, OpenNewTabTargetType, POSITION, SCREEN_SIZE } from '@voltmoney/types';
import { BorderRadiusTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignContent, StackAlignItems, StackJustifyContent, StackSelfContent, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { closePopup } from "./action";
import { getScreenType } from "../../configs/platfom-utils";
import { Dimensions, Platform } from "react-native";
import { DeepLinks } from "../../configs/config";
import SharedPropsService from "../../SharedPropsService";
import { heightMap } from "../../configs/height";
import { getContactNumberForCall, getContactNumberForWhatsapp } from "../../configs/uri-config-utils";
import { AMPLITUDE_EVENT } from "../../configs/constants";
import { addSupportAmplitudeEvent, isIframe } from "../../configs/utils";
export const template = async (whatsappNumber, callNumber, emailId, openNewTab, instrumentTrack, isFromPhonePe, isFromJupiter, showCall, showEmail, showWA, noOfHeights, fromInProgressProcess, amountToPay, isFromDashboard, showSupportPhoneNumber) => {
    return {
        layout: {
            id: ROUTE.CONTACT_US_CARD,
            type: LAYOUTS.MODAL,
            style: {
                height: noOfHeights === 3 ? heightMap[ROUTE.CONTACT_US_3_CARDS] : noOfHeights === 2 ? heightMap[ROUTE.CONTACT_US_2_CARDS] : noOfHeights === 1 ? heightMap[ROUTE.CONTACT_US_1_CARDS] : isFromJupiter ? heightMap[ROUTE.CONTACT_US_CARD_JUPITER] : heightMap[ROUTE.CONTACT_US_CARD],
            },
            widgets: [
                { id: "mainContainerCard", type: WIDGET.CARD, position: POSITION.ABSOLUTE_BOTTOM },
            ],
        },
        datastore: {
            mainContainerStack: {
                type: StackType.column,
                width: StackWidth.FULL,
                justifyContent: StackJustifyContent.center,
                alignContent: StackAlignContent.center,
                alignSelf: StackSelfContent.center,
                alignItems: StackAlignItems.center,
                padding: {
                    left: SizeTypeTokens.MD,
                    right: SizeTypeTokens.MD
                },
                widgetItems: [
                    { id: 'space16', type: WIDGET.SPACE },
                    { id: "headerStack", type: WIDGET.STACK },
                    { id: 'topSpace', type: WIDGET.SPACE },
                    showWA ? {
                        id: 'whatsappCard',
                        type: WIDGET.CARD,
                    } : {},
                    { id: 'space1', type: WIDGET.SPACE },
                    (showCall && showSupportPhoneNumber) ? {
                        id: 'callCard',
                        type: WIDGET.CARD,
                    } : {},
                    { id: 'space2', type: WIDGET.SPACE },
                    showEmail ? {
                        id: 'emailCard',
                        type: WIDGET.CARD,
                    } : {},
                    Platform.OS === 'ios' ? { id: 'space6', type: WIDGET.SPACE } : {},
                ]
            },
            space6: {
                size: SizeTypeTokens.XL
            },
            headerStack: {
                type: StackType.row,
                width: StackWidth.MATCH_PARENT,
                justifyContent: StackJustifyContent.spaceBetween,
                widgetItems: [
                    { id: "headerTitle", type: WIDGET.TEXT },
                    { id: "cancelIconStack", type: WIDGET.STACK }
                ]
            },
            headerTitle: {
                label: 'Reach out to us',
                fontSize: FontSizeTokens.MD,
                fontWeight: '600',
                lineHeight: 24,
                fontFamily: FontFamilyTokens.Poppins
            },
            cancelIconStack: {
                id: 'bt_contactUs_cancel',
                type: StackType.column,
                width: StackWidth.CONTENT,
                justifyContent: StackJustifyContent.center,
                alignSelf: StackSelfContent.center,
                alignItems: StackAlignItems.center,
                alignContent: StackAlignContent.center,
                borderConfig: {
                    borderRadius: BorderRadiusTokens.BR6
                },
                // padding: {
                //     all: SizeTypeTokens.XS
                // },
                widgetItems: [
                    { id: "cancelIcon", type: WIDGET.ICON }
                ],
                action: {
                    type: ACTION.CLOSE_POP_UP,
                    routeId: ROUTE.CONTACT_US_CARD,
                    payload: {
                        fromInProgressProcess: fromInProgressProcess,
                        amountToPay: amountToPay,
                        isFromDashboard: isFromDashboard
                    }
                }
            },
            cancelIcon: {
                name: IconTokens.Cross,
                size: IconSizeTokens.XXL,
                color: ColorTokens.Grey_Night
            },
            space0: { size: SizeTypeTokens.XL },
            list1: {
                id: 'txt_contactUs_whatsApp',
                customTitle: {
                    label: 'WhatsApp',
                    color: ColorTokens.Grey_Night,
                    fontFamily: FontFamilyTokens.Inter,
                    fontWeight: '600',
                    fontSize: FontSizeTokens.SM,
                    lineHeight: 20,
                },
                customSubTitle: {
                    label: 'We usually reply within 5-10 mins. We’re available on Mon-Sat from 9:30 AM to 6:30 PM',
                    color: ColorTokens.Grey_Charcoal,
                    fontFamily: FontFamilyTokens.Inter,
                    fontWeight: '400',
                    fontSize: FontSizeTokens.XS,
                    lineHeight: 18,
                },
                isDivider: false,
                rightIcon: true,
                title: 'WhatsApp',
                leadIconName: IconTokens.Whatsapp,
                onPress: () => {
                    addSupportAmplitudeEvent(instrumentTrack, AMPLITUDE_EVENT.CONTACT_VIA_WA_BUTTON_CLICKED);
                    const screenType = getScreenType(Dimensions.get('window').width);
                    if (isFromPhonePe) {
                        openNewTab('whatsapp://send?phone=+919611749097&text=Hi', OpenNewTabTargetType.parent);
                    }
                    else {
                        if (isIframe()) {
                            openNewTab(DeepLinks.WHATSAPP + whatsappNumber, OpenNewTabTargetType.blank);
                        }
                        else if (screenType === SCREEN_SIZE.X_SMALL ||
                            screenType === SCREEN_SIZE.SMALL) {
                            openNewTab(DeepLinks.MOBILE_WHATSAPP + whatsappNumber, OpenNewTabTargetType.parent);
                        }
                        else {
                            openNewTab(DeepLinks.WHATSAPP + whatsappNumber, OpenNewTabTargetType.blank);
                        }
                    }
                },
            },
            whatsappCard: {
                needBorder: true,
                bgColor: ColorTokens.Primary_02,
                borderColor: ColorTokens.Primary_20,
                borderWidth: 1,
                borderRadius: BorderRadiusTokens.BR3,
                margin: {
                    top: SizeTypeTokens.NONE,
                    bottom: SizeTypeTokens.NONE
                },
                body: {
                    widgetItems: [{ id: 'list1', type: WIDGET.LIST_ITEM }],
                },
            },
            space1: { size: SizeTypeTokens.XL },
            mainContainerCard: {
                bgColor: ColorTokens.White,
                width: '100%',
                borderColor: ColorTokens.Primary_05,
                borderWidth: 1,
                borderTopRightRadius: BorderRadiusTokens.BR5,
                borderTopLeftRadius: BorderRadiusTokens.BR5,
                margin: {
                    top: SizeTypeTokens.NONE,
                    bottom: SizeTypeTokens.NONE
                },
                padding: {
                    left: SizeTypeTokens.MD,
                    right: SizeTypeTokens.MD
                },
                body: {
                    widgetItems: [
                        Platform.OS === "ios" ? { id: 'space16', type: WIDGET.SPACE } : {},
                        { id: 'space3', type: WIDGET.SPACE },
                        { id: "headerStack", type: WIDGET.STACK },
                        { id: "space8", type: WIDGET.SPACE },
                        { id: 'info', type: WIDGET.TEXT },
                        { id: 'space0', type: WIDGET.SPACE },
                        showWA ? {
                            id: 'whatsappCard',
                            type: WIDGET.CARD,
                        } : {},
                        (showCall && showSupportPhoneNumber) ? { id: 'space1', type: WIDGET.SPACE } : {},
                        (showCall && showSupportPhoneNumber) ? {
                            id: 'callCard',
                            type: WIDGET.CARD,
                        } : {},
                        showEmail ? { id: 'space2', type: WIDGET.SPACE } : {},
                        showEmail ? {
                            id: 'emailCard',
                            type: WIDGET.CARD,
                        } : {},
                    ],
                },
            },
            space2: { size: SizeTypeTokens.XL },
            space3: { size: SizeTypeTokens.XL },
            callCard: {
                needBorder: true,
                bgColor: ColorTokens.Primary_02,
                borderColor: ColorTokens.Primary_20,
                borderWidth: 1,
                borderRadius: BorderRadiusTokens.BR3,
                margin: {
                    top: SizeTypeTokens.NONE,
                    bottom: SizeTypeTokens.NONE
                },
                body: {
                    widgetItems: [
                        { id: 'list2', type: WIDGET.LIST_ITEM },
                    ],
                },
            },
            list2: {
                id: 'txt_contactUs_call',
                customTitle: {
                    label: 'Call',
                    color: ColorTokens.Grey_Night,
                    fontFamily: FontFamilyTokens.Inter,
                    fontWeight: '600',
                    fontSize: FontSizeTokens.SM,
                },
                customSubTitle: {
                    label: `Call us at ${callNumber}. We’re available on Mon-Sat from 9:30 AM to 6:30 PM`,
                    color: ColorTokens.Grey_Charcoal,
                    fontFamily: FontFamilyTokens.Inter,
                    fontWeight: '400',
                    fontSize: FontSizeTokens.XS,
                    lineHeight: 18,
                },
                isDivider: false,
                rightIcon: true,
                title: 'Call',
                leadIconName: IconTokens.Phone,
                onPress: () => {
                    addSupportAmplitudeEvent(instrumentTrack, AMPLITUDE_EVENT.CONTACT_VIA_CALL_BUTTON_CLICKED);
                    openNewTab(DeepLinks.CALL + callNumber, OpenNewTabTargetType.parent);
                },
            },
            emailCard: {
                needBorder: true,
                bgColor: ColorTokens.Primary_02,
                borderColor: ColorTokens.Primary_20,
                borderWidth: 1,
                borderRadius: BorderRadiusTokens.BR3,
                margin: {
                    top: SizeTypeTokens.NONE,
                    bottom: SizeTypeTokens.XXXL
                },
                body: {
                    widgetItems: [{ id: 'list3', type: WIDGET.LIST_ITEM }],
                },
            },
            list3: {
                id: 'txt_contactUs_email',
                customTitle: {
                    label: 'Email',
                    color: ColorTokens.Grey_Night,
                    fontFamily: FontFamilyTokens.Inter,
                    fontWeight: '600',
                    fontSize: FontSizeTokens.SM,
                },
                customSubTitle: {
                    label: `Email us at ${emailId}. We usually respond within 2 hours`,
                    color: ColorTokens.Grey_Charcoal,
                    fontFamily: FontFamilyTokens.Inter,
                    fontWeight: '400',
                    fontSize: FontSizeTokens.XS,
                    lineHeight: 18,
                },
                isDivider: false,
                rightIcon: true,
                title: 'Email',
                subTitle: `Email us at ${emailId}`,
                leadIconName: IconTokens.Email,
                onPress: () => {
                    addSupportAmplitudeEvent(instrumentTrack, AMPLITUDE_EVENT.CONTACT_VIA_EMAIL_BUTTON_CLICKED);
                    openNewTab(DeepLinks.MAILTO + emailId, OpenNewTabTargetType.parent);
                },
            },
            info: {
                label: isFromJupiter ? 'We would love to hear from you. You can get back to us via Call, Email' : !(showCall && showSupportPhoneNumber) ? 'We would love to hear from you. You can get back to us via WhatsApp or Email' : 'We would love to hear from you. You can get back to us via WhatsApp, Call or Email',
                color: ColorTokens.Grey_Charcoal,
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
            },
            space8: {
                size: SizeTypeTokens.MD
            },
            space24: {
                size: SizeTypeTokens.XXXL
            },
            space16: {
                size: SizeTypeTokens.XL
            },
            topSpace: { size: SizeTypeTokens.XL },
        },
    };
};
export const contactUsCardMF = {
    onLoad: async ({ openNewTab, instrumentTrack }, { fromInProgressProcess, amountToPay, isFromDashboard }) => {
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER" /* AppPlatform.JUPITER */;
        const callData = await SharedPropsService.getCallData();
        const emailData = await SharedPropsService.getEmailData();
        const showCall = await SharedPropsService.getShowCall();
        const showSupportPhoneNumber = await SharedPropsService.getSupportPhoneNumber();
        const showEmail = await SharedPropsService.getShowEmail();
        const showWA = await SharedPropsService.getShowWA();
        const waData = await SharedPropsService.getWAData();
        const url = await SharedPropsService.getURL();
        const whatsappDeepLinkDesktop = waData ? waData : await getContactNumberForWhatsapp(url);
        const callDeepLink = callData ? callData : await getContactNumberForCall(url);
        const emailId = emailData ? emailData : isFromJupiter ? 'support@jupiter.money' : 'support@voltmoney.in';
        let isFromPhonePe = await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */;
        let noOfHeights;
        console.warn("BVH showCall showSupportPhoneNumber", showCall, showSupportPhoneNumber);
        const conditionsMet = [showWA, (showCall && showSupportPhoneNumber), showEmail].filter(Boolean).length;
        switch (conditionsMet) {
            case 3:
                noOfHeights = 3;
                break;
            case 2:
                noOfHeights = 2;
                break;
            case 1:
                noOfHeights = 1;
                break;
            default:
                noOfHeights = 0;
                break;
        }
        addSupportAmplitudeEvent(instrumentTrack, AMPLITUDE_EVENT.CONTACT_SUPPORT_BUTTON_CLICKED);
        return Promise.resolve(template(whatsappDeepLinkDesktop, callDeepLink, emailId, openNewTab, instrumentTrack, isFromPhonePe, isFromJupiter, showCall, showEmail, showWA, noOfHeights, fromInProgressProcess, amountToPay, isFromDashboard, showSupportPhoneNumber));
    },
    actions: {
        [ACTION.CLOSE_POP_UP]: closePopup,
    },
    clearPrevious: false,
};
